import { Link } from "react-router-dom";
import { Clock, MapPin, ArrowUpRight } from "lucide-react";

export default function TourCard({ tour, index = 0 }) {
  return (
    <Link
      to={`/tours/${tour.slug}`}
      data-testid={`tour-card-${tour.slug}`}
      className="group bg-white border border-[#d4af37]/25 hover:border-[#d4af37]/60 transition-all duration-500 flex flex-col overflow-hidden"
    >
      <div className="relative overflow-hidden aspect-[4/3]">
        <img src={tour.banner_image} alt={tour.name} loading="lazy"
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1200ms]" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2d1616]/60 via-transparent to-transparent" />
        <span className="absolute top-4 left-4 text-[10px] tracking-[0.2em] uppercase bg-[#fdfbf7]/95 text-[#7c1d1d] px-3 py-1 backdrop-blur">
          {tour.category}
        </span>
        {tour.duration_label && (
          <span className="absolute bottom-4 left-4 flex items-center gap-1.5 text-xs text-white">
            <Clock className="w-3.5 h-3.5 text-[#e8c970]" /> {tour.duration_label}
          </span>
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-serif text-2xl text-[#3b1a1a] leading-tight group-hover:text-[#7c1d1d] transition-colors">{tour.name}</h3>
        {tour.destinations?.length > 0 && (
          <div className="mt-2 flex items-center gap-1.5 text-[11px] tracking-wide text-[#5a4b4b]">
            <MapPin className="w-3.5 h-3.5 text-[#14523d]" /> {tour.destinations.slice(0, 4).join(" · ")}
          </div>
        )}
        <p className="text-sm text-[#5a4b4b] mt-3 leading-relaxed clamp-3">{tour.overview}</p>
        <div className="mt-auto pt-5 flex items-center justify-between border-t border-[#d4af37]/20 mt-5">
          <span className="text-[11px] tracking-[0.2em] uppercase text-[#14523d]">Enquire · No fixed price</span>
          <span className="inline-flex items-center justify-center w-9 h-9 border border-[#3b1a1a]/25 group-hover:bg-[#7c1d1d] group-hover:text-white group-hover:border-[#7c1d1d] transition-all">
            <ArrowUpRight className="w-4 h-4" />
          </span>
        </div>
      </div>
    </Link>
  );
}
